var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "queryParams",
          attrs: {
            model: _vm.queryParams,
            inline: "",
            "label-width": "80px",
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "请假时间" } },
            [
              _c("el-date-picker", {
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                on: {
                  input: function ($event) {
                    return _vm.change($event)
                  },
                },
                model: {
                  value: _vm.leaveDate,
                  callback: function ($$v) {
                    _vm.leaveDate = $$v
                  },
                  expression: "leaveDate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "请假类型" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请输入请假类型" },
                  model: {
                    value: _vm.queryParams.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "type", $$v)
                    },
                    expression: "queryParams.type",
                  },
                },
                [
                  _vm._l(_vm.leaveTypeOptionList, function (item) {
                    return [
                      _c("el-option", {
                        attrs: { value: item.dictValue, label: item.dictLabel },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { "label-width": "0px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.refresh()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("table-page", {
        ref: "tablePage",
        attrs: {
          url: "oa/leave/getMeLeavePageList",
          columns: _vm.columns,
          "query-params": _vm.queryParams,
          "check-box": false,
        },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function (ref) {
              var row = ref.row
              return _vm._l(_vm.leaveTypeOptionList, function (item) {
                return row.type === item.dictValue
                  ? _c("el-tag", { attrs: { type: item.listClass } }, [
                      _vm._v(
                        "\n        " + _vm._s(item.dictLabel) + "\n      "
                      ),
                    ])
                  : _vm._e()
              })
            },
          },
          {
            key: "status",
            fn: function (ref) {
              var row = ref.row
              return [
                row.status === "1"
                  ? _c("el-tag", { attrs: { type: "warning" } }, [
                      _vm._v("未开始"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                row.status === "2"
                  ? _c("el-tag", { attrs: { type: "primary" } }, [
                      _vm._v("进行中"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                row.status === "3"
                  ? _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("已完成"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                row.status === "4"
                  ? _c("el-tag", { attrs: { type: "danger" } }, [
                      _vm._v("驳回"),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "action",
            fn: function (ref) {
              var row = ref.row
              return [
                row.status === "1"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.submit(row)
                          },
                        },
                      },
                      [_vm._v("提交")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                row.status === "4"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.reSubmit(row)
                          },
                        },
                      },
                      [_vm._v("重新提交")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                row.status !== "1"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.track(row)
                          },
                        },
                      },
                      [_vm._v("追踪")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
            close: function ($event) {
              return _vm.handleReset("form")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入姓名" },
                    on: {
                      input: function ($event) {
                        return _vm.change($event)
                      },
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "请假时间", prop: "beginDate" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm",
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "请假开始日期",
                      "end-placeholder": "请假结束日期",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.change($event)
                      },
                    },
                    model: {
                      value: _vm.form.leaveDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "leaveDate", $$v)
                      },
                      expression: "form.leaveDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "请假类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入请假类型" },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    [
                      _vm._l(_vm.leaveTypeOptionList, function (item) {
                        return [
                          _c("el-option", {
                            attrs: {
                              value: item.dictValue,
                              label: item.dictLabel,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "请假事由", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入请假事由" },
                    on: {
                      input: function ($event) {
                        return _vm.change($event)
                      },
                    },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleReset("form")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmit("form")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "追踪",
            visible: _vm.dialogTrackShow,
            width: "80%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTrackShow = $event
            },
          },
        },
        [
          _vm.dialogTrackShow
            ? _c("track-process", {
                attrs: { "process-instance-id": _vm.processInstanceId },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }